
import React from 'react';
import { motion } from 'framer-motion';
import CartSellerGroup from './CartSellerGroup';
import MobileHeader from '../mobile/MobileHeader';
import { CartItem } from '../../types';
import { Lock } from 'lucide-react';
import OfflineIndicator from './OfflineIndicator';

interface CartLayoutMobileProps {
    sellers: Record<string, CartItem[]>;
    totalPrice: number;
    totalItems: number;
    onRemove: (listingId: string) => void;
    onCheckout: (sellerId: string | null, sellerName: string, amount: number) => void;
    onClearCart: () => void;
}

const CartLayoutMobile: React.FC<CartLayoutMobileProps> = ({
    sellers,
    totalPrice,
    totalItems,
    onRemove,
    onCheckout,
    onClearCart
}) => {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-950 pb-32">
            <MobileHeader
                title={`Sepetim (${totalItems})`}
                showBack
                rightElement={
                    <button
                        onClick={onClearCart}
                        className="text-[10px] font-black text-gray-400 dark:text-gray-500 hover:text-rose-500 dark:hover:text-rose-400 transition-all uppercase tracking-widest bg-gray-100 dark:bg-gray-900 px-3 py-1.5 rounded-lg"
                    >
                        Temizle
                    </button>
                }
            />

            <OfflineIndicator />

            <div className="p-4 space-y-6">
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="space-y-6"
                >
                    {Object.keys(sellers).map(sellerId => (
                        <CartSellerGroup
                            key={sellerId}
                            sellerId={sellerId}
                            items={sellers[sellerId]}
                            onRemove={onRemove}
                            onCheckout={Object.keys(sellers).length > 1 ? onCheckout : undefined}
                            isMobile={true}
                        />
                    ))}
                </motion.div>
            </div>

            {/* Sticky Bottom Checkout Bar (Mobile Only) */}
            <div className="fixed bottom-0 left-0 right-0 p-6 bg-white dark:bg-gray-950 border-t border-gray-100 dark:border-gray-800 shadow-[0_-8px_30px_rgba(0,0,0,0.08)] z-40 pb-[calc(1.5rem+env(safe-area-inset-bottom))]">
                <div className="flex items-center justify-between mb-4">
                    <span className="text-gray-400 dark:text-gray-500 font-black uppercase tracking-[0.2em] text-[10px]">Genel Toplam</span>
                    <span className="text-3xl font-black text-gray-950 dark:text-white uppercase tracking-tighter italic">₺{totalPrice.toLocaleString('tr-TR')}</span>
                </div>

                {Object.keys(sellers).length > 1 ? (
                    <button
                        onClick={() => onCheckout(null, '', totalPrice)}
                        className="w-full py-5 bg-gray-950 dark:bg-white text-white dark:text-gray-950 rounded-2xl font-black uppercase tracking-[0.2em] shadow-2xl flex items-center justify-center gap-3 active:scale-95 transition-all text-sm"
                    >
                        <Lock size={18} strokeWidth={3} />
                        Sepeti Onayla
                    </button>
                ) : (
                    <button
                        onClick={() => {
                            const sid = Object.keys(sellers)[0];
                            const sName = sellers[sid][0].sellerName || 'Satıcı';
                            onCheckout(sid, sName, totalPrice);
                        }}
                        className="w-full py-5 bg-gray-950 dark:bg-white text-white dark:text-gray-950 rounded-2xl font-black uppercase tracking-[0.2em] shadow-2xl flex items-center justify-center gap-3 active:scale-95 transition-all text-sm"
                    >
                        <Lock size={18} strokeWidth={3} />
                        Sepeti Onayla
                    </button>
                )}
            </div>
        </div>
    );
};

export default CartLayoutMobile;
